import React from "react";
import store from "../../../state/store";

const ClinvarTokenHelp = () => {
  const state = store.getState();
  const userEmail = state.userEmail || state.user?.email;
  const userName =
    state.userName || `${state.user?.first_name} ${state.user?.last_name}`;
  const userOrganization = state.userOrganisation;

  const CLINVAR_EMAIL_TEXT = `Dear ClinVar team%2C%0D%0A%0D%0APlease create a service account for 
    my organization ${userOrganization}. %0D%0A%0D%0AThe contact email address is ${userEmail}.%0D%0A%0D%0ABest regards%2C%0D%0A${userName}`;
  return (
    <div>
      <ul>
        <li>
          If you haven&apos;t already done so, register your organization on
          ClinVar. Instructions on how to do that can be found here:{" "}
          <a
            href="https://www.ncbi.nlm.nih.gov/clinvar/docs/submission_portal/"
            target="_blank"
          >
            ClinVar Submission Portal
          </a>
        </li>
        <li>
          Request a service account from ClinVar by contacting:{" "}
          <a
            href={`mailto:clinvar@ncbi.nlm.nih.gov?subject=Request%20for%20Service%20Account&body=${CLINVAR_EMAIL_TEXT}`}
          >
            clinvar@ncbi.nlm.nih.gov
          </a>{" "}
        </li>
        <li>
          Obtain your ClinVar API Key for your service account by following the
          instructions on this page:{" "}
          <a href="https://www.ncbi.nlm.nih.gov/clinvar/docs/api_http/">
            ClinVar Submission API
          </a>
        </li>
      </ul>
    </div>
  );
};

export default ClinvarTokenHelp;
